import {ON_STOCK_BALANCE,ON_STOCK_BALANCE_UNCOUNTED,
    ON_TRANSACTION_TREND,ON_INCOMPLETE_TRANSACTIONS,
    ON_PENDING_INTENTS,ON_REJECTED_INTENTS,
    ON_PENDING_CONSIGNMENTS,ON_REJECTED_CONSIGNMENTS} from '../constants/ActionTypes';

const INIT_STATE = {
    stockBalances: [],
    stockBalancesUncounted:[],
    transactionTrends: [],
    pendingIntents: [],
    pendingConsignments: [],
    incompleteTransactions: [],
};


export default (state=INIT_STATE,action) => {
    switch (action.type){

        case ON_STOCK_BALANCE: {
            return {...state, stockBalances: action.payload};
        }
        case ON_STOCK_BALANCE_UNCOUNTED: {
            return {...state, stockBalancesUncounted: action.payload};
        }
        case ON_TRANSACTION_TREND: {
            return {...state, transactionTrends: action.payload};
        }
        case ON_PENDING_INTENTS: {
            return {...state, pendingIntents: action.payload};
        }
        case ON_PENDING_CONSIGNMENTS: {
            return {...state, pendingConsignments: action.payload};
        }
        case ON_INCOMPLETE_TRANSACTIONS: {
            return {...state, incompleteTransactions: action.payload};
        }
        case ON_REJECTED_INTENTS: {
            return {...state, rejectedIntents: action.payload};
        }
        case ON_REJECTED_CONSIGNMENTS: {
            return {...state, rejectedConsignments: action.payload};
        }
        default:
            return state;
    }
}